import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5c175f14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "business" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "business_title" }, [
  /*#__PURE__*/_createTextVNode(" Prevent Practitioner Burnout with Sixliv: "),
  /*#__PURE__*/_createElementVNode("p", null, "Your 24/7 Clinic Operations Partner.")
], -1))
const _hoisted_3 = { class: "business_cards" }
const _hoisted_4 = { class: "sign" }

import BusinessCard from "./BusinessCard.vue";
import { useData } from "@/utils/store";
import { onMounted, reactive, watchEffect } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Business',
  setup(__props) {

const pageData=useData()

const pics = reactive<{
  pic: { url: string; title: string; content: string; digest: string }[];
}>({
  pic: [],
});
watchEffect(() => {
  const {FUN_ZONE}=pageData.globalData.value
  console.log('PAGE_MODEL_2--------',FUN_ZONE)
  if(FUN_ZONE){
    pics.pic=FUN_ZONE[0].children
  }
})
onMounted(() => {
  if (localStorage.getItem("FUN_ZONE")) {
    pics.pic = JSON.parse(localStorage.getItem("FUN_ZONE") || "")[0].children || [];
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pics.pic, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "business_cards_wrapper",
          key: item.url
        }, [
          _createVNode(BusinessCard, {
            title: item.title,
            url: item.url,
            content: item.content,
            digest: item.digest
          }, null, 8, ["title", "url", "content", "digest"])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_link, {
        to: "/register",
        class: "sign"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Sign Up")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})